import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Loader from '../../../core/components/Loader/Loader';
import ProductTilesApi from './api/ProductTilesApi';
import styles from './ProductTiles.module.scss';
import TranslationService from '../../../core/services/TranslationService';

const ProductTiles = () => {
    const [isDataLoading, setIsDataLoading] = useState<boolean>(false);
    const [productTiles, setProductTiles] = useState<any>();

    const fetchProductTiles = async () => {
        setIsDataLoading(true);

        try {
            const productTiles = await ProductTilesApi.getProductTiles();
            setProductTiles(productTiles);

        } finally {
            setIsDataLoading(false);
        }
    }

    useEffect(() => {
        fetchProductTiles();
    }, []);

    return (
        <Container className={styles.moduleTiles}>
            <Row className={productTiles && productTiles.length > 0 ? '' : 'justify-content-start'}>
                {isDataLoading
                    ? <Loader />
                    : productTiles && productTiles.length > 0 ? productTiles.map((group: any) => {
                        return (
                            <Col sm={6} md={4} key={group.title}>
                                <section>
                                    {group.tiles.map((tile: any) => {
                                        const product = tile.icon.replace(/\s/g, '').toLowerCase();

                                        return (
                                            <div 
                                                className={`${styles.tile} ${styles[`tile--${product}`]}`} 
                                                key={product} 
                                                onClick={() => {
                                                    window.open(tile.link);
                                                }}
                                            >
                                                <div className={styles['tile__icon']} />
                                                <p>{tile.title}</p>
                                            </div>
                                        )
                                    })}
                                </section>
                            </Col>
                        )
                    }) :
                        (<section className={styles['info-text']}>
                            <h4>{TranslationService.translate('NoTilesToDisplay')}</h4>
                        </section>)
                }
            </Row>
        </Container>
    )
}

export default ProductTiles;